import { memo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useAnalytics } from 'use-analytics';
import { flightSearch } from '../../../../../store/slices/flight';
import MultiSelectAutocompleteFilter from '../../../../Filters/MultiSelectAutocompleteFilter';
import flightSearchInput from '../../../../../helpers/selectors/flightSearchInput';
import { setFlightTripSearchInputs } from '../../../../../store/slices/tripSearch';

const AirlineFlightFilter = ({ tripId, variant, filterSpacingClass }) => {
  const dispatch = useDispatch();
  const { track } = useAnalytics();
  const isTripSearch = !tripId;
  const {
    searchInputs, airlinesAutocompleteResults,
  } = useSelector(flightSearchInput(tripId, isTripSearch));

  const handleChange = (newValue) => {
    const payload = {
      tripId,
      searchObj: {
        filterAirlines: newValue,
        page: 1,
      },
    };

    if (isTripSearch) {
      dispatch(setFlightTripSearchInputs({ ...payload.searchObj }));
      dispatch(flightSearch({ isTripSearch: true, ...payload.searchObj }));
    } else dispatch(flightSearch(payload));
    track('airlineFlightFilter.handleChange', {
      filterAirlines: JSON.stringify(newValue),
    });
  };

  return (airlinesAutocompleteResults || []).length ? (
    <MultiSelectAutocompleteFilter
      onChange={handleChange}
      label="Filter by airlines"
      tooltipPrependText="Filter by airlines"
      options={airlinesAutocompleteResults || []}
      values={searchInputs.filterAirlines || []}
      variant={variant}
      filterMaxWidthClass="max-w-full"
      filterSpacingClass={filterSpacingClass}
      bgClassName={!isTripSearch ? '' : undefined}
    />
  ) : <></>;
};

AirlineFlightFilter.propTypes = {
  tripId: PropTypes.string,
  filterSpacingClass: PropTypes.string,
  variant: PropTypes.string,
};

AirlineFlightFilter.defaultProps = {
  tripId: undefined,
  filterSpacingClass: undefined,
  variant: undefined,
};

export default memo(AirlineFlightFilter);
